import React, { useState } from "react";
import ReactDOM from "react-dom";

const AddMaterialModal = ({ isOpen, onClose, categories, onSaveMaterial, onAddCategory }) => {
    if (!isOpen) return null;

    const [newMaterial, setNewMaterial] = useState({
        displayName: "",
        file: null,
        categoryID: "",
        materialType: "",
        display: true
    });
    const [addingCategory, setAddingCategory] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState("");
    const [loading, setLoading] = useState(false);

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!newMaterial.displayName || !newMaterial.file || !newMaterial.categoryID) {
            alert("Please fill all fields before uploading.");
            return;
        }

        try {
            setLoading(true);
            await onSaveMaterial(newMaterial);
            onClose();
        } catch (err) {
            console.error(err);
            alert("Error uploading material");
        } finally {
            setLoading(false);
        }
    };

    const handleSaveCategoryInline = async () => {
        if (!newCategoryName.trim()) return;
        const id = await onAddCategory(newCategoryName.trim());
        if (id) {
            setNewMaterial((prev) => ({ ...prev, categoryID: id }));
        }
        setAddingCategory(false);
        setNewCategoryName("");
    };

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Upload New Material</h3>
                    <button className="close-button" onClick={onClose}>✕</button>
                </div>

                <div className="modal-body">
                    <form onSubmit={handleUpload}>
                        {/* Display Name */}
                        <div className="form-group">
                            <label>Display Name</label>
                            <input
                                type="text"
                                className="filterInput"
                                value={newMaterial.displayName}
                                onChange={(e) =>
                                    setNewMaterial({ ...newMaterial, displayName: e.target.value })
                                }
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Material Type</label>
                            <select
                                className="filterInput"
                                value={newMaterial.materialType || ""}
                                onChange={(e) => {
                                        setNewMaterial({
                                            ...newMaterial,
                                            materialType: e.target.value,
                                        });
                                    }
                                }
                                required
                            >
                            <option value="">Material Type</option>
                            <option value="POLICY">Policy</option>
                            <option value="AGENT">Agent</option>
                            </select>
                        </div>

                        {/* File Upload */}
                        <div className="form-group">
                            <label>File</label>
                            <input
                                type="file"
                                className="filterInput"
                                onChange={(e) =>
                                    setNewMaterial({ ...newMaterial, file: e.target.files[0] })
                                }
                                required
                            />
                        </div>

                        {/* Category Selection or Add Inline */}
                        {!addingCategory ? (
                            <div className="form-group">
                                <label>Category</label>
                                <select
                                    className="filterInput"
                                    value={newMaterial.categoryID || ""}
                                    onChange={(e) => {
                                        if (e.target.value === "new") {
                                            setAddingCategory(true);
                                        } else {
                                            setNewMaterial({
                                                ...newMaterial,
                                                categoryID: parseInt(e.target.value),
                                            });
                                        }
                                    }}
                                    required
                                >
                                    <option value="">Select Category</option>
                                    {categories.map((cat) => (
                                        <option key={cat.categoryID} value={cat.categoryID}>
                                            {cat.categoryName}
                                        </option>
                                    ))}
                                    <option value="new">➕ Add new category…</option>
                                </select>
                            </div>
                        ) : (
                            <div className="form-group inline-add-category">
                                <label>New Category Name</label>
                                <input
                                    type="text"
                                    className="filterInput"
                                    value={newCategoryName}
                                    onChange={(e) => setNewCategoryName(e.target.value)}
                                    placeholder="Enter category name"
                                />
                                <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                                    <button
                                        type="button"
                                        className="baseButton"
                                        onClick={handleSaveCategoryInline}
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        className="baseButton secondary"
                                        onClick={() => setAddingCategory(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="form-group">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={newMaterial.display || false}
                                    onChange={(e) =>
                                        setNewMaterial({
                                            ...newMaterial,
                                            display: e.target.checked,
                                        })
                                    }
                                />
                                Display?
                            </label>
                        </div>

                        {/* Form Actions */}
                        <div className="form-actions">
                            <button
                                type="submit"
                                className="baseButton"
                                disabled={loading}
                            >
                                {loading ? "Uploading..." : "Upload"}
                            </button>
                            <button
                                type="button"
                                className="baseButton secondary"
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default AddMaterialModal;
